export const TestIds = {
  bgOverlay: 'bgOverlay',
} as const;
